module.exports = __webpack_public_path__ + "img/yt.6fe184e.svg";